/**
 * removes every locale from the pathname
 * @param pathname the current pathname
 * @param locales the list of the possible app's locales
 */
export function getPathnameWithoutLocale<T extends string>({
  pathname,
  locales,
}: {
  pathname: T;
  locales: string[];
}): T {
  const escaped = locales.map((l) => l.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');
  return pathname.replace(new RegExp(`^/(${escaped})(?:/|$)`), '/') as T;
}
